import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, postData } from "src/utils/axios/serverHelper";

import {
	TQC1060_R01DetailDto,
	TQC1060_R01Dto,
	TQC1060_R01HeaderDto,
} from "./Dto_TQC1060_R01";

const baseUrl = `${config.apiUrl}/TQC1060_R01`;

export interface TQC1060_R01Params {
	compCd?: string;
	startDate?: string;
	endDate?: string;
	inoutClass?: string;
	customCd?: string;
	itemCd?: string;
}

export interface TQC1060_R01DetailParams {
	itemCd: string;
	inspectNo?: string;
}

export interface TQC1060_R01CertificateParams {
	transportNo: string;
	itemNo: string;
}

export const getTQC1060_R01List = (option: string, params: TQC1060_R01Params) =>
	getData<ResponseDto<TQC1060_R01HeaderDto[]>>(`${baseUrl}/${option}`, { params });

export const getTQC1060_R01AllCount = (params: TQC1060_R01Params) =>
	getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params });

export const getTQC1060_R01DetailList = (params: TQC1060_R01DetailParams) =>
	getData<ResponseDto<TQC1060_R01DetailDto[]>>(`${baseUrl}/detail`, { params });

export const postTQC1060_R01 = (data: TQC1060_R01Dto) =>
	postData<TQC1060_R01Dto, ResponseDto<number>>(`${baseUrl}/save`, data);

export const deleteTQC1060_R01 = (list: TQC1060_R01HeaderDto[]) =>
	postData<TQC1060_R01HeaderDto[], ResponseDto<number>>(`${baseUrl}/delete`, list);

export const downloadExcel_TQC1060_R01 = (params: TQC1060_R01Params) =>
	getData<ResponseDto<string>>(`${baseUrl}/excel`, { params });

export const downloadCertificatePdf_TQC1060_R01 = (
	params: TQC1060_R01CertificateParams,
) =>
	getData<Blob>(`${baseUrl}/report/certificate`, {
		params,
		responseType: "blob",
		headers: { Accept: "application/pdf" },
	});
